import {isRTL} from '../../Localization';

export type MessageDetails = {
    MovingDay: string;
    hour: string;
};

export type Message = {
    type: string;
    details: MessageDetails;
};

export const messageTypeText = 'Accounts';
export const accountsAlertCookie = 'accountsAlertShown';
export const monitorText = 'POP_Accounts_OK';

export const supportUrl = 'https://support.priority-software.com/';

export enum DialogText {
    title = 'title',
    intro = 'intro',
    loginEmail = 'loginEmail',
    emailMissing = 'emailMissing',
    updateEmail = 'updateEmail',
    watchVideo = 'watchVideo',
    linkText = 'linkText',
    linkSuffix = 'linkSuffix',
    acceptBtn = 'acceptBtn'
}

const en = {
    title: 'We are Moving to Accounts Login',
    intro: 'you will sign in to Priority using your email address - a faster, simpler, and more secure way to access the system.',
    loginEmail: 'Your login email:',
    emailMissing: 'Your email will be shown here once configured.',
    updateEmail:
        'Not seeing your email? Update it in the Users form or contact your administrator before the transition.',
    watchVideo: 'Watch a quick setup guide:',
    linkText: 'How to sign in with Accounts Login',
    linkSuffix: 'en/kb/LBI2500499/English',
    acceptBtn: 'OK, got it'
};

const he = {
    title: 'עוברים להתחברות באמצעות Priority Accounts',
    intro: ' ההתחברות ל-Priority תהיה באמצעות כתובת האימייל שלך - דרך מהירה, פשוטה ומאובטחת יותר להיכנס למערכת.',
    loginEmail: 'כתובת האימייל שלך להתחברות היא:',
    emailMissing: 'זה המקום שבו יוצג האימייל שלך.',
    updateEmail:
        'האימייל לא מופיע כאן? יש להגדיר את האימייל במסך משתמשי מערכת או לפנות למנהל/ת המערכת לפני המעבר.',
    watchVideo: 'צפו בסרטון קצר:',
    linkText: 'התחברות לפריוריטי עם Priority Accounts',
    linkSuffix: 'he/kb/LBI2500318/Hebrew',
    acceptBtn: 'הבנתי'
};

export const getHardcodedText = (key: DialogText): string => {
    return isRTL() ? he[key] : en[key];
};
